import styled from 'styled-components';

export const TabsContentWrapperStyled = styled.div`
  position: relative;
  min-height: 20rem;
  display: flex;
`;
